module.exports = __webpack_public_path__ + "img/20191007155000433.c1b68cd1.jpg";